/*
 * forced-item.js — keeps a mandatory item in the cart and blocks its removal.
 * Item: "Processing Fee" (product 9435077345503) -> variant 50511083176159.
 * Behaviour: whenever the cart has at least one real item, the fee is present
 * (qty 1) and its Remove link + quantity controls are hidden/locked. If the
 * cart has no real items, the fee is taken out so idle carts aren't just a fee.
 */
(function () {
  var FORCED_VARIANT = 50511083176159;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;

  function cartJson() {
    return fetch(ROOT + 'cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) { return r.json(); });
  }
  function post(url, body) {
    return fetch(ROOT + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    });
  }
  function sectionHtml(id) {
    return fetch(ROOT + '?section_id=' + encodeURIComponent(id), { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) { return r.text(); });
  }
  function esc(s) { return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/["\\]/g, '\\$&'); }

  function refreshUI() {
    var jobs = [];
    ['MiniCart-', 'MainCart-'].forEach(function (prefix) {
      var el = document.querySelector('[id^="' + prefix + '"]');
      if (!el) return;
      var id = el.id.slice(prefix.length);
      jobs.push(sectionHtml(id).then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(prefix + id);
        if (fresh) el.innerHTML = fresh.innerHTML;
      }).catch(function () {}));
    });
    jobs.push(cartJson().then(function (c) {
      document.querySelectorAll('cart-count').forEach(function (n) {
        n.textContent = c.item_count;
        if (c.item_count > 0) { n.removeAttribute('hidden'); } else { n.setAttribute('hidden', ''); }
      });
    }).catch(function () {}));
    return Promise.all(jobs).then(function () { setTimeout(lock, 60); });
  }

  function lock() {
    cartJson().then(function (cart) {
      var line = cart.items.filter(function (i) { return i.variant_id === FORCED_VARIANT; })[0];
      if (!line) return;
      document.querySelectorAll('[data-index="' + esc(line.key) + '"]').forEach(function (el) {
        if (el.tagName === 'A') {
          el.style.display = 'none'; el.setAttribute('aria-hidden', 'true'); el.tabIndex = -1;
        } else if (el.tagName === 'INPUT') {
          el.readOnly = true; el.setAttribute('aria-disabled', 'true');
          el.style.pointerEvents = 'none'; el.style.opacity = '.65';
          var wrap = el.closest('.quantity, quantity-input, .cart-quantity');
          if (wrap) wrap.querySelectorAll('.quantity__button').forEach(function (b) { b.style.display = 'none'; });
        }
      });
    }).catch(function () {});
  }

  function enforce() {
    if (busy) return;
    busy = true;
    cartJson().then(function (cart) {
      var fee = cart.items.filter(function (i) { return i.variant_id === FORCED_VARIANT; })[0];
      var others = cart.items.filter(function (i) { return i.variant_id !== FORCED_VARIANT; });

      if (others.length === 0) {
        if (fee) return post('cart/change.js', { id: fee.key, quantity: 0 }).then(refreshUI);
        return;
      }
      if (!fee) return post('cart/add.js', { id: FORCED_VARIANT, quantity: 1 }).then(refreshUI);
      if (fee.quantity !== 1) return post('cart/change.js', { id: fee.key, quantity: 1 }).then(refreshUI);
      lock();
    }).catch(function () {}).then(function () { busy = false; });
  }

  /* ajaxProduct:added fires reliably after every add-to-cart (independent of the
     theme's own cart re-render, which can fail) — this is the key hook. */
  document.addEventListener('ajaxProduct:added', function () { setTimeout(enforce, 400); });
  document.addEventListener('cart:updated', function () { setTimeout(enforce, 250); });
  document.addEventListener('modal:afterShow', function () { setTimeout(lock, 80); });
  document.addEventListener('DOMContentLoaded', enforce);
  enforce();
})();
